export enum EnrollmentStatus {
  'automatic' = 'automatic',
  'manual' = 'manual',
  'async' = 'async',
  'engine' = 'engine'
}
